// @ts-nocheck
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import Ref from 'models/propTypes/ref';

import focusManager from 'support/focus/FocusManager';
import textToSpeechManager from 'support/tts/TextToSpeechManager';

import { withFocusSettings } from './FocusSettingsContext';

class Focusable extends React.PureComponent {
  state = {
    hasFocus: false,
  };

  focusId = null;

  constructor(props) {
    super(props);

    this.focusId = props.focusId || focusManager.getNewUniqueId();
  }

  componentDidMount() {
    const { hasInitialFocus, onFocusSet, ttsText } = this.props;

    focusManager.register(this.focusId, this.onAction, this.onFocusSet);

    if (hasInitialFocus) {
      focusManager.setCurrentFocus(this.focusId);
    }

    if (focusManager.currentFocusId === this.focusId) {
      this.setState({ hasFocus: true });
      onFocusSet(true);
    }

    if (ttsText && this.focusId) {
      textToSpeechManager.register(this.focusId, ttsText);
    }
  }

  componentDidUpdate() {
    const { ttsText } = this.props;
    if (ttsText && this.focusId) {
      textToSpeechManager.register(this.focusId, ttsText);
    }
  }

  componentWillUnmount() {
    focusManager.unregister(this.focusId);
    textToSpeechManager.unregister(this.focusId);
  }

  onAction = action => {
    const { onAction } = this.props;
    return onAction(action);
  };

  onFocusSet = value => {
    const { ttsOnFocusEnabled } = this.props;
    if (value && ttsOnFocusEnabled) {
      const { ttsText } = this.props;

      if (ttsText) {
        textToSpeechManager.add(ttsText);
        textToSpeechManager.speak();
      }
    }

    const { onFocusSet } = this.props;
    this.setState({
      hasFocus: value,
    });
    onFocusSet(value);
  };

  onMouseEnter = () => {
    // focusManager.setCurrentFocus(this.focusId);
  };

  render() {
    const {
      onAction,
      onFocusSet,
      className,
      divRef,
      focusId,
      disableFocusOnHover,
      render,
      hasInitialFocus,
      ttsText,
      ttsOnFocusEnabled,
      ...rest
    } = this.props;
    const { hasFocus } = this.state;

    return (
      <div
        ref={divRef}
        className={classNames('_fcsc', 'focusable-div', className)}
        data-fcsid={this.focusId}
        // onMouseEnter={() => {
        //   if (!disableFocusOnHover) {
        //     this.onMouseEnter();
        //   }
        // }}
        {...rest}
      >
        {render({ hasFocus })}
      </div>
    );
  }
}

Focusable.propTypes = {
  onAction: PropTypes.func,
  onFocusSet: PropTypes.func,
  className: PropTypes.string,
  focusId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  hasInitialFocus: PropTypes.bool,
  disableFocusOnHover: PropTypes.bool,
  render: PropTypes.func.isRequired,
  divRef: Ref,
  ttsText: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),
  ttsOnFocusEnabled: PropTypes.bool,
};

Focusable.defaultProps = {
  onAction: () => false,
  onFocusSet: () => {},
  className: null,
  focusId: null,
  hasInitialFocus: false,
  disableFocusOnHover: false,
  divRef: null,
  ttsText: null,
  ttsOnFocusEnabled: true,
};

const EnhancedFocusable = withFocusSettings(Focusable);

export default React.forwardRef((props, ref) => (
  <EnhancedFocusable divRef={ref} {...props} />
));
